import React from 'react';
import { Box, Typography } from '@mui/material';

function GeneralValueWidget({ widget, data, theme }) {
  const isDark = theme === 'dark';
  const liveData = Array.isArray(data) ? data : [];
  const tagprops = widget?.props?.extended?.tagprops || [];
  const basic = widget?.props?.basic || {};

  const values = tagprops.map((tp) => {
    const match = liveData.find((d) => String(d.TagId) === String(tp.tagId));
    return { name: tp.alias || tp.tagId, value: match?.value ?? '—', unit: tp.unit || '' };
  });

  if (widget.type === 'Single Value') {
    const v = values[0];
    return (
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 1, px: 0.5, width: '100%' }}>
        <Typography variant="caption" sx={{ color: isDark ? '#aaa' : '#666' }}>{v?.name || '—'}</Typography>
        <Typography variant="h4" sx={{ color: isDark ? '#fff' : '#000', fontWeight: 700, fontFamily: basic.fontType || 'Roboto', fontSize: { xs: '1.5rem', sm: '2rem' } }}>
          {v?.value ?? '—'}
        </Typography>
        {v?.unit && <Typography variant="caption" sx={{ color: isDark ? '#aaa' : '#666' }}>{v.unit}</Typography>}
      </Box>
    );
  }

  const displayRows = values.length > 0
    ? values
    : [{ name: '—', value: '—', unit: '' }];

  return (
    <Box sx={{ flex: 1, minHeight: 0, width: '100%', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', py: 0.5, px: 1, overflow: 'hidden' }}>
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly' }}>
        {displayRows.map((v, i) => (
          <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: '1 1 0', minHeight: 0, borderBottom: `1px solid ${isDark ? '#333' : '#eee'}`, py: 0.25 }}>
            <Typography variant="body2" sx={{ color: isDark ? '#aaa' : '#666', pr: 1 }}>{v.name}</Typography>
            <Typography variant="body2" sx={{ color: isDark ? '#fff' : '#000', fontWeight: 700 }}>
              {v.value} {v.unit}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default React.memo(GeneralValueWidget);
